export default __webpack_public_path__ + "static/media/challanpreview.f39faa47.jpg";